import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './Auth';
import { API_URL } from './config';
// ?? ?????????
import { FaUser, FaEnvelope, FaLock, FaRocket, FaPuzzlePiece } from 'react-icons/fa';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data } = await axios.post(`${API_URL}/register`, { name, email, password });
      login(data);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
           <div style={{ marginBottom: 10, color: '#00b894' }}>
             <FaPuzzlePiece size={50} />
          </div>
          <h2 style={styles.title}>Create Account</h2>
          <p style={styles.subtitle}>Start creating puzzle books</p>
        </div>

        {error && <div style={styles.errorAlert}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Full Name</label>
            <div style={styles.inputWrapper}>
              <div style={styles.iconContainer}>
                <FaUser size={16} color="#a4b0be" />
              </div>
              <input 
                type="text" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
                required 
                placeholder="John Doe"
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Email Address</label>
            <div style={styles.inputWrapper}>
              <div style={styles.iconContainer}>
                <FaEnvelope size={16} color="#a4b0be" />
              </div>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
                placeholder="name@example.com"
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <div style={styles.inputWrapper}>
              <div style={styles.iconContainer}>
                <FaLock size={16} color="#a4b0be" />
              </div>
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                placeholder="Create a password"
                style={styles.input}
              />
            </div>
          </div>

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Creating...' : <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}><FaRocket /> Sign Up Free</span>}
          </button>
        </form>

        <div style={styles.footer}>
          <p>Already have an account? <span onClick={() => navigate('/login')} style={styles.link}>Login Here</span></p>
        </div>
      </div>
    </div>
  );
};

// Styles (??? styles ???? Login)
const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', fontFamily: "'Segoe UI', sans-serif" },
  card: { width: '100%', maxWidth: '400px', background: 'white', padding: '40px', borderRadius: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' },
  header: { textAlign: 'center', marginBottom: '30px' },
  title: { margin: '0', color: '#2d3436', fontSize: '24px', fontWeight: 'bold' },
  subtitle: { margin: '5px 0 0', color: '#636e72', fontSize: '14px' },
  errorAlert: { background: '#ffebee', color: '#c62828', padding: '10px', borderRadius: '5px', marginBottom: '20px', fontSize: '13px', textAlign: 'center', border: '1px solid #ffcdd2' },
  inputGroup: { marginBottom: '20px' },
  label: { display: 'block', marginBottom: '8px', color: '#2d3436', fontSize: '14px', fontWeight: '600' },
  inputWrapper: { display: 'flex', alignItems: 'center', background: '#f1f2f6', borderRadius: '8px', border: '1px solid #dfe6e9', overflow: 'hidden' },
  iconContainer: { padding: '0 15px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' },
  input: { flex: 1, border: 'none', background: 'transparent', padding: '12px 10px 12px 0', fontSize: '15px', outline: 'none', color: '#2d3436' },
  button: { width: '100%', padding: '14px', background: '#00b894', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', transition: '0.2s' },
  footer: { marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#636e72' },
  link: { color: '#0984e3', cursor: 'pointer', fontWeight: 'bold', textDecoration: 'underline' }
};

export default Register;